import { useQuery, useQueryClient } from "react-query";
import { getDecisionAccess } from "../api/decision/access";
import useAxiosPrivate from "./useAxiosPrivate";

export const STATUS_LABELS = {
	draft: "Draft",
	ongoing: "Ongoing",
	done: "Done",
	archive: "Archived",
};

/**
 * Access of a decision and what the current user may do with it. While loading, or for a new decision, nothing is permitted.
 */
export default function useDecisionAccess(id) {
	const { axiosPrivate } = useAxiosPrivate();
	const queryClient = useQueryClient();
	const key = ["decision-access", String(id)];
	const query = useQuery(key, () => getDecisionAccess(axiosPrivate, id), { enabled: Boolean(id), retry: false });
	const permissions = query.data?.permissions ?? {};

	return {
		...query,
		access: query.data,
		permissions,
		canEdit: Boolean(permissions.editContent),
		canWork: Boolean(permissions.owner || permissions.collaborator),
		refreshDecision: () => {
			queryClient.invalidateQueries(key);
			queryClient.invalidateQueries(["decision-id", id]);
			queryClient.invalidateQueries(["decision-id", String(id)]);
		},
	};
}
